import { render, staticRenderFns } from "./TopWarning.vue?vue&type=template&id=dc35ede8&scoped=true&"
import script from "./TopWarning.vue?vue&type=script&lang=js&"
export * from "./TopWarning.vue?vue&type=script&lang=js&"
import style0 from "./TopWarning.vue?vue&type=style&index=0&id=dc35ede8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc35ede8",
  null
  
)

component.options.__file = "TopWarning.vue"
export default component.exports